<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <search-condition :show-shadow="false">
        <el-input v-model="searchInfo.searchKey" placeholder="请输入客户名称/编辑" @keydown.enter="listResetSearch" clearable>
          <template #prefix>客户名称/编辑</template>
        </el-input>
        <template #option>
          <page-button @click="listResetSearch" el-type="primary">查询</page-button>
        </template>
      </search-condition>
      <list-table class="content-table" background-color="#FFF" :show-shadow="false">
        <yq-table :data="dataList" ref="table">
          <yq-table-column label="客户名称" prop="btypeName" :show-overflow-tooltip="true" />
          <yq-table-column label="客户编码" prop="btypeUserCode" :show-overflow-tooltip="true" />
          <yq-table-column label="操作" prop="option" align="center">
            <template #header>
              <table-button @click="addLines()">添加</table-button>
            </template>
            <template v-slot="{$index}">
              <table-button el-type="danger" @click="deleteRow($index)">删除</table-button>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
    </list-page>
    <el-dialog v-model="showDialog" title="添加客户" dialog-width="3">
      <dialog-table>
        <separator-page :show-shadow="false" :show-border="true">
          <template #category>
            <tree-dictionary :filter="true" v-model:dictionary-list="customerCategories" :disabled="true"
                             label-name="fullName"
                             @clickCategory="clickCategory" :query-function="queryCategory" dialog-label="部门管理">
            </tree-dictionary>
          </template>
          <list-page>
            <search-condition :show-shadow="false">
              <el-input v-model="dialogSearchInfo.searchKey" placeholder="请输入客户名称/编辑">
                <template #prefix>客户名称/编辑</template>
              </el-input>
              <template #option>
                <page-button @click="dialogResetSearch" el-type="primary">查询</page-button>
              </template>
            </search-condition>
            <list-table :show-shadow="false">
              <yq-table :data="dialogDataList" ref="dialogTable" @selectionChange="selectionChange">
                <yq-table-column type="selection"/>
                <yq-table-column label="客户名称" prop="fullName" :show-overflow-tooltip="true" />
                <yq-table-column label="客户编码" prop="userCode" :show-overflow-tooltip="true" />
                <yq-table-column label="操作" prop="option" align="center">
                  <template v-slot="{row}">
                    <table-button @click="selectOne(row)">选择</table-button>
                  </template>
                </yq-table-column>
              </yq-table>
            </list-table>
            <form-page v-model:page-number="dialogSearchInfo.pageNumber" v-model:page-size="dialogSearchInfo.pageSize" :total-count="dialogSearchInfo.totalCount" @onLoad="dialogQueryList" :show-shadow="false">
              <page-button @click="showDialog = false">取消</page-button>
              <page-button el-type="primary" @click="toAddRelation">确定</page-button>
              <page-button el-type="warning" @click="toAddByParent">按分类添加全部</page-button>
            </form-page>
          </list-page>
        </separator-page>
      </dialog-table>
    </el-dialog>
  </div>
</template>

<script>


import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import qywxXbotSolutionApi from "@/api/dz-ai/qywxXbotSolutionApi";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
export default {
  props: {
    id: {default: ""},
  },
  name: "",
  components: {
    TreeDictionary,
    TableButton,
    FormPage, PageButton,
    YqTableColumn,
    YqTable, ListTable,
    ListPage, DialogTable, SeparatorPage, SearchCondition
  },
  data() {
    return {
      allDataList: [],
      dataList: [],
      showDialog: false,
      dialogDataList: [],
      dialogSearchInfo: {},
      selectedList: [],
      customerCategories: [],
      queryCategory: null,
      searchInfo: {},

    };
  },
  created() {
    // 查询分类的方法
    this.queryCategory = qywxXbotSolutionApi.queryBtypeCategory;
    this.init();
  },
  methods: {
    init() {
      if (this.id) {
        qywxXbotSolutionApi.queryAllBtypeList(this.id).then(list => {
          this.allDataList = list;
          this.dataList = list;
        });
      }
    },
    addLines() {
      this.showDialog = true;
      // 如果列表没有数据，就刷新
      if (!this.dialogDataList.length) {
        this.dialogResetSearch();
      }
    },
    dialogResetSearch() {
      this.dialogSearchInfo.pageNumber = 1;
      this.dialogQueryList();
    },
    dialogQueryList() {
      qywxXbotSolutionApi.queryBtypeByPage(this.dialogSearchInfo).then(data => {
        this.dialogDataList = data.records;
        this.dialogSearchInfo.totalCount = data.totalCount;
      });
    },
    clickCategory(data) {
      this.dialogSearchInfo.parentId = data.typeId;
      this.dialogResetSearch();
    },
    deleteRow(index) {
      // 点击过快
      if (index >= this.dataList.length) {
        this.$refs.table.showDataColumns();
        return;
      }
      let row = this.dataList[index];
      if (row.id) {
        qywxXbotSolutionApi.deleteRelation(row.id).then(() => {
          this.dataList.splice(index, 1);
          this.$refs.table.showDataColumns();
        });
      } else {
        this.dataList.splice(index, 1);
        this.$refs.table.showDataColumns();
      }
    },
    // 选中单条数据
    selectOne(data) {
      let arr = [data.typeId];
      qywxXbotSolutionApi.addRelation(this.id, arr).then(() => {
        this.init();
        this.showDialog = false;
      });
    },
    // 多条数据，选中
    selectionChange(list) {
      this.selectedList = list;
    },
    // 添加已选中的全部
    toAddRelation() {
      if (!this.selectedList.length) {
      this.$message.error("请选择客户");
        return;
      }
      // 按id添加
      let arr = [];
      this.selectedList.forEach(i => arr.push(i.typeId));
      qywxXbotSolutionApi.addRelation(this.id, arr).then(() => {
        this.init();
        this.showDialog = false;
      })
    },
    // 按分类添加全部
    toAddByParent() {
      if (!this.dialogSearchInfo.parentId) {
        this.$message.error("请选择分类");
        return;
      }
      // 按分类添加
      qywxXbotSolutionApi.queryAllBtypeByParentId(this.dialogSearchInfo.parentId).then(data => {
        let arr = [];
        data.forEach(i => arr.push(i.typeId));
        qywxXbotSolutionApi.addRelation(this.id, arr).then(() => {
          this.init();
          this.showDialog = false;
        });
      });
    },
    // 在列表中搜索
    listResetSearch() {
      if (!this.searchInfo.searchKey) {
        this.dataList = this.allDataList;
      } else {
        let k = this.searchInfo.searchKey.toUpperCase();
        let arr = [];
        for (let i = 0; i < this.allDataList.length; i++) {
          if (this.allDataList[i].btypeName.toUpperCase().indexOf(k) >= 0 || this.allDataList[i].btypeUserCode.toUpperCase().indexOf(k) >= 0) {
            arr.push(this.allDataList[i]);
          }
        }
        this.dataList = arr;
      }
      this.$refs.table.showDataColumns();
    }
  }
};
</script>

<style lang="scss" scoped>

</style>